<form [formGroup]="formBuilder">
  <div class="row align-middle align-items-center mt-2">
    <div class="col-3">
      <input type="date" formControlName="date" class="form-text-fw" (change)="changeDate()">
    </div>
    <div class="col-3 d-inline-flex align-items-center">
      <div class="col d-inline-flex align-items-center">
        <span>Dalle: </span>
        <select formControlName="mFrom" class="form-time form-control"
          [ngClass]="{'is-invalid': formControls.mFrom.status === 'INVALID' && form.touched === true}"
          aria-label="form-select-sm" (change)="changeMFrom()">
          <option value="" selected>--:--</option>
          <option *ngFor="let opt of SpecialOpeninghoursView.mFrom" value="{{opt}}">{{opt}}</option>
        </select>
      </div>
      <div class="col d-inline-flex align-items-center">
        <span class="ms-2">Alle: </span>
        <select formControlName="mTo" class="form-time form-control"
          [ngClass]="{'is-invalid': formControls.mTo.status === 'INVALID' && form.touched === true}"
          aria-label="form-select-sm" (change)="changeMTo()">
          <option value="" selected>--:--</option>
          <option *ngFor="let opt of SpecialOpeninghoursView.mTo" value="{{opt}}">{{opt}}</option>
        </select>
      </div>
    </div>
    <div class="col-3 d-inline-flex">
      <div class="col d-inline-flex align-items-center">
        <span>Dalle: </span>
        <select formControlName="eFrom" class="form-time form-control"
          [ngClass]="{'is-invalid': formControls.eFrom.status === 'INVALID' && form.touched === true}"
          aria-label="form-select-sm" (change)="changeEFrom()">
          <option value="" selected>--:--</option>
          <option *ngFor="let opt of SpecialOpeninghoursView.eFrom" value="{{opt}}">{{opt}}</option>
        </select>
      </div>
      <div class="col d-inline-flex align-items-center">
        <span class="ms-2">Alle: </span>
        <select formControlName="eTo" class="form-time form-control"
          [ngClass]="{'is-invalid': formControls.eTo.status === 'INVALID' && form.touched === true}"
          aria-label="form-select-sm" (change)="changeETo()">
          <option value="" selected>--:--</option>
          <option *ngFor="let opt of SpecialOpeninghoursView.eTo" value="{{opt}}">{{opt}}</option>
        </select>
      </div>
    </div>
    <div class="col-3 d-flex justify-content-end">
      <input type="text" formControlName="note" class="form-text-fw" placeholder="Nota" (change)="changeValue()">
    </div>
  </div>
</form>